import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { groupValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import GroupForm from "./GroupForm";
import { useLocation } from "react-router-dom";

const CreateGroup = (props: any) => {
  const location = useLocation();
  const defaultService = location.state?.service;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(groupValidationForm),
    defaultValues: async () => ({
      service: defaultService,
    }),
  });

  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <GroupForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        isEdit={false}
        watch={watch}
        control={control}
        getValues={getValues}
      />
    </FormLayout>
  );
};

export default CreateGroup;
